// ** React Imports
import React from 'react'
import { useSelector } from 'react-redux'

// ** Styles Imports
import styles from './orderbook.module.css'

// ** Component Imports
import OrderbookBody from './OrderbookBody'
import OrderbookHeader from './OrderbookHeader'

function Orderbook() {
  const theme = useSelector(state => state.theme.value)

  return (
    <div className={`${styles.card} ${theme === 'light' ? styles.light : ''}`}>
      <OrderbookHeader />
      <OrderbookBody />
    </div>
  )
}

export default Orderbook
